import { Controller } from '@hotwired/stimulus'
import Swal from "sweetalert2";

export default class extends Controller {
  static targets = ["inputJustificativaCliente", "inputRadioButton"]
  static values = {
    anexosArrayLength: Number
  }

  initialize() {
    let radioChecked = this.inputRadioButtonTargets.filter((el) => el.checked == true)
    this.anexosArrayLengthValue = 0

    if (radioChecked.length <= 0) this.inputJustificativaClienteTarget.hidden = true
  }

  adicionarAnexo(){
    if (this.anexosArrayLengthValue >= 5) {  
      var addButton = document.getElementById('add-button');
      addButton.hidden = true
    } else {
      this.anexosArrayLengthValue += 1

      //div agregador
      var containerDiv = document.createElement('div');
      containerDiv.id = `anexoContainer_${this.anexosArrayLengthValue}`
  
      //button delete
      var deleteButton = document.createElement('button')
      deleteButton.type = 'button'
      deleteButton.innerHTML = "Remover"
      deleteButton.classList.add("remove-anexo")
      deleteButton.name = `anexobotao_${this.anexosArrayLengthValue}`
      deleteButton.onclick = (e)=> {
        var childIndex = e.target.name.split("_")[1]
        if (childIndex){
          var div = document.getElementById(`anexoContainer_${childIndex}`)
          if (div){
            div.remove()
            var addButton = document.getElementById('add-button');
            addButton.removeAttribute('hidden')
            this.anexosArrayLengthValue -= 1
          } 
        }
      }
  
      //input file
      var fileInput = document.createElement('input');
      fileInput.type = 'file';
      fileInput.name = `solicitacao_estorno[anexos_solicitacao_estorno_attributes][${this.anexosArrayLengthValue-1}][anexo]`;
  
      //appending to root
      var divRaiz = document.getElementById('anexos-container');
      containerDiv.appendChild(fileInput)
      containerDiv.appendChild(deleteButton)
      divRaiz.appendChild(containerDiv) //root
    }
  }

  submitForm(event) {
    event.preventDefault();

    Swal.fire({
      title: I18n.t("mensagem_confirmar_solicitacao_estorno_title"),
      text: I18n.t("mensagem_confirmar_solicitacao_estorno_text"),
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: I18n.t("sim_continuar"),
      cancelButtonText: I18n.t("cancelar"),
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        event.target.form.submit();
      }
    });
    return;
  }

  alterouRadioButton(event) {
    let processoAutomatico = event.srcElement.getAttribute('processo-automatico');
    processoAutomatico == 'true' ? this.inputJustificativaClienteTarget.hidden = true : this.inputJustificativaClienteTarget.hidden = false
  }
}